import { createTheme, ThemeProvider, CssBaseline } from "@mui/material";
import { useState, useMemo } from "react";
import getTheme from "./getTheme";

export const MuiThemeProvider = ({ children }) => {
  const [mode, setMode] = useState("light");

  const appTheme = useMemo(() => createTheme(getTheme(mode)), [mode]);

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
